import { BehaviorSubject, Subject } from 'rxjs';

export class HttpRequestService {
  running$: Subject<boolean> = new BehaviorSubject(false);
  private _running = false;

  get running(): boolean {
    return this._running;
  }

  private set running(r: boolean) {
    this._running = r;
    this.running$.next(r);
  }

  start() {
    this.running = true;
  }

  complete() {
    this.running = false;
  }
}
